


import { Component, Vue, Prop } from "vue-property-decorator";

@Component
export default class FieldSubscriptionStatus extends Vue {
    @Prop() public Value!: string;

    /* Mappe le statut brut sur une couleur de badge façon Stripe. */
    private get variant(): string {
        switch( this.Value ) {
            case "Active":
                return "success";

            case "Trial":
            case "Offer":
                return "info";

            case "PastDue":
            case "Unpaid":
            case "Incomplete":
                return "danger";

            case "Canceled":
            case "Incompleted_Expired":
            default:
                return "neutral";
        }
    }
}
